import { Text } from 'components/Ui-Kits/Text'
import { bool, number, string } from 'prop-types'
import styled from 'styled-components'
import { forwardRef } from 'react'
import { useAppTranslation } from 'i18n/hooks'

export const Item = forwardRef(({ active, image, slotNumber, total, startingPrice, disabled }, ref) => {
  const { t } = useAppTranslation()

  return (
    <ItemWrap active={active} ref={ref}>
      <Image alt="" src={image} loading="lazy" />
      <Description>
        <Text bold color="primary">
          {t('lotNumber')} {slotNumber} / {total}
        </Text>
        <Text>Lähtöhinta {startingPrice} €</Text>
      </Description>
      {disabled && (
        <DisabledWrap>
          <Text bold color="primary">
            {t('itemIsntAvailable')}
          </Text>
        </DisabledWrap>
      )}
    </ItemWrap>
  )
})

Item.displayName = 'Item'

Item.propTypes = {
  active: bool,
  image: string,
  slotNumber: number,
  startingPrice: number,
  total: number,
  disabled: bool,
}

const ItemWrap = styled.div`
  background-color: var(--color-white);
  padding: 0.75rem;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 1rem;
  ${({ active }) => active && `border: 2px solid var(--color-primary);`}
`

const Image = styled.img`
  width: 50px;
  height: 50px;
`

const Description = styled.div`
  margin-left: 1.5rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`

const DisabledWrap = styled.div`
  background-color: var(--color-white);
  z-index: 10;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
